import * as CL from '@design-system/component-library';
import { type ReactNode } from 'react';

export const OpenFormButton = ({ text, ...props }: { text?: ReactNode } & CL.ButtonProps) => (
  <CL.Button {...props}>{text}</CL.Button>
);
